var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getAccessToken, getSession } from "../utils/auth0";
import { buildIdentityUrl } from "../utils/identity-url";
function safeJson(response) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            return (yield response.clone().json());
        }
        catch (_a) {
            return response.text();
        }
    });
}
export function handleIdentityResetPassword(req, res) {
    return __awaiter(this, void 0, void 0, function* () {
        if (req.method !== "POST") {
            res.status(405).json({ message: "Method not allowed" });
            return;
        }
        try {
            const session = yield getSession(req, res);
            if (!(session === null || session === void 0 ? void 0 : session.user)) {
                res.status(401).json({ message: "Not authenticated" });
                return;
            }
            const { accessToken } = yield getAccessToken(req, res);
            const identityUrl = buildIdentityUrl("/v1/user/password/request-reset");
            const upstream = yield fetch(identityUrl, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`,
                },
                cache: "no-store",
            });
            if (!upstream.ok) {
                const errorBody = yield safeJson(upstream);
                // eslint-disable-next-line no-console
                console.error("Identity service error:", {
                    status: upstream.status,
                    body: errorBody,
                });
                res.status(upstream.status).json({
                    message: "Failed to request password reset from identity service",
                    upstreamStatus: upstream.status,
                    error: errorBody,
                });
                return;
            }
            const resetData = yield upstream.json();
            res.setHeader("Cache-Control", "no-store");
            res.status(200).json(resetData);
        }
        catch (error) {
            // eslint-disable-next-line no-console
            console.error("Identity reset password endpoint error:", error);
            res.status(500).json({
                message: "Internal server error",
                error: error instanceof Error ? error.message : "Unknown error",
            });
        }
    });
}
